import { IconType } from "react-icons";
import {
  SiSpringboot,
  SiFlask,
  SiPython,
  SiAngular,
  SiReact,
  SiTailwindcss,
  SiTypescript,
  SiJavascript,
  SiHtml5,
  SiCss,
  SiPostgresql,
  SiMysql,
  SiRedis,
  SiDocker,
  SiGit,
  SiLinux,
  SiPostman,
  SiDbeaver,
  SiGrafana,
  SiPrometheus,
  SiApachekafka,
  SiRabbitmq,
} from "react-icons/si";
import { FaJava } from "react-icons/fa6";
import { TbApi, TbDatabase, TbBrandAws, TbBrandAzure, TbMessageCircle, TbBroadcast } from "react-icons/tb";

export interface Skill {
  name: string;
  icon: IconType;
}

/** Sourced from Murilo's resume "Technical Skills" section. */
export const skillGroups: Record<string, Skill[]> = {
  backend: [
    { name: "Java", icon: FaJava },
    { name: "Spring Boot", icon: SiSpringboot },
    { name: "Python", icon: SiPython },
    { name: "Flask", icon: SiFlask },
    { name: "REST APIs", icon: TbApi },
  ],
  frontend: [
    { name: "Angular", icon: SiAngular },
    { name: "React", icon: SiReact },
    { name: "Tailwind CSS", icon: SiTailwindcss },
    { name: "TypeScript", icon: SiTypescript },
    { name: "JavaScript", icon: SiJavascript },
    { name: "HTML", icon: SiHtml5 },
    { name: "CSS", icon: SiCss },
  ],
  messaging: [
    { name: "Kafka", icon: SiApachekafka },
    { name: "RabbitMQ", icon: SiRabbitmq },
    { name: "STOMP", icon: TbBroadcast },
    { name: "ActiveMQ", icon: TbMessageCircle },
  ],
  database: [
    { name: "PostgreSQL", icon: SiPostgresql },
    { name: "MySQL", icon: SiMysql },
    { name: "Redis", icon: SiRedis },
    { name: "SQL", icon: TbDatabase },
  ],
  devops: [
    { name: "Docker", icon: SiDocker },
    { name: "Git", icon: SiGit },
    { name: "Linux", icon: SiLinux },
    { name: "AWS", icon: TbBrandAws },
    { name: "Microsoft Azure", icon: TbBrandAzure },
  ],
  tools: [
    { name: "Postman", icon: SiPostman },
    { name: "DBeaver", icon: SiDbeaver },
    { name: "Grafana", icon: SiGrafana },
    { name: "Prometheus", icon: SiPrometheus },
  ],
};
